import { IScheduleIntervalStoreSegment } from './scheduleInterval.interface';

export const scheduleIntervalStoreSelector = (state: IScheduleIntervalStoreSegment) => state.scheduleInterval;
